export function composeMap(coreMap, legacyMap) {
  const actions = new Set([...Object.keys(coreMap), ...Object.keys(legacyMap)]);
  const composed = {};

  for (const action of actions) {
    composed[action] = mergeEntry(action, coreMap[action], legacyMap[action]);
  }

  return composed;
}

const MERGEABLE_LEGACY_FIELDS = Object.freeze(['idKeys', 'parentNameKeys', 'parentValueKeys', 'keyAliases']);

function mergeEntry(action, coreEntry, legacyAlternate) {
  if (!legacyAlternate) return coreEntry;
  if (!coreEntry) {
    throw new Error(`shape-map: legacy alternate declared for '${action}' with no core entry`);
  }
  const unmergeable = Object.keys(legacyAlternate).filter(field => !MERGEABLE_LEGACY_FIELDS.includes(field));
  if (unmergeable.length > 0) {
    throw new Error(`shape-map: legacy alternate for '${action}' declares unmergeable ${unmergeable.join(', ')}`);
  }

  return {
    ...coreEntry,
    idKeys: [...(coreEntry.idKeys ?? []), ...(legacyAlternate.idKeys ?? [])],
    parentNameKeys: [...(coreEntry.parentNameKeys ?? []), ...(legacyAlternate.parentNameKeys ?? [])],
    parentValueKeys: [...(coreEntry.parentValueKeys ?? []), ...(legacyAlternate.parentValueKeys ?? [])],
    keyAliases: { ...(coreEntry.keyAliases ?? {}), ...(legacyAlternate.keyAliases ?? {}) },
  };
}
